/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/
 */

// Lib imports
import { createRouter, createWebHistory } from 'vue-router'
import Paths from './paths'

const routes = [...Paths]

routes.push({ path: '/:pathMatch(.*)*', redirect: '/' })

// Create a new router
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
